import { db, functions } from '@/firebase';
import firebase from 'firebase';
import { createSlug } from '@/utils/utils.js';
import moment from 'moment';

export default {
  getTodosRestaurantes({ commit }) {
    var snap = db.collection('restaurantesLigero').onSnapshot(
      (res) => {
        let devolver = [];
        res.forEach((doc) => {
          let aux = doc.data();
          aux.id = doc.id;
          devolver.push(aux);
        });
        commit('setRestaurantesTodosArray', devolver);
      },
      (e) => {
        console.log(e);
      }
    );
    //commit('restaurantes/restaurantesTodosSnap', snap, { root: true })
    return snap;
  },
  getRestaurantesDirectorio({ rootState, commit }) {
    const negocios = JSON.parse(
      JSON.stringify(rootState.app.directorioObjGest.negocios)
    );
    // let negociosArray = new Array(Math.ceil(negocios.length / 10))
    //     .fill()
    //     .map(_ => negocios.splice(0, 10))
    if (Array.isArray(rootState.app.directorioObjGest.restaurantes)) {
      return Promise.all(
        rootState.app.directorioObjGest.restaurantes.map((r) => {
          return db
            .collection('restaurantesLigero')
            .doc(r)
            .get()
            .then((res) => {
              if (res.exists) {
                return {
                  ...res.data(),
                  id: res.id,
                };
              }
            });
        })
      ).then((r) => {
        commit(
          'setRestaurantesDirectorio',
          r.filter((s) => !!s)
        );
      });
    } else {
      commit('setRestaurantesDirectorio', []);
      return;
    }

    if (negociosArray.length > 0) {
      return Promise.all(
        negociosArray.map((n) => {
          return db
            .collection('restaurantes')
            .where('negocio', 'in', n)
            .get()
            .then(
              (res) => {
                let devolver = [];
                res.forEach((doc) => {
                  let aux = doc.data();
                  aux.id = doc.id;
                  devolver.push(aux);
                });
                return devolver;
              },
              (e) => {
                console.log(e);
              }
            );
        })
      )
        .then((r) => {
          commit('setRestaurantesDirectorio', r.flat());
        })
        .catch((e) => console.log);
    } else {
      commit('setRestaurantesDirectorio', []);
    }
  },
  getRestaurantes({ commit, rootState, dispatch }) {
    let negocio = rootState.app.negocioGest;
    var flag = true;
    let devolver = [];
    var snap = db
      .collection('restaurantes')
      .where('negocio', '==', negocio)
      .onSnapshot(
        (res) => {
          let devolver = [];
          res.forEach((doc) => {
            let aux = doc.data();
            aux.id = doc.id;
            devolver.push(aux);
          });
          commit('setRestaurantesArray', devolver);
          if (flag) {
            flag = false;
            dispatch('getModosRestaurantes');
            dispatch('getConfTpv');
          }
        },
        (e) => {
          console.log(e);
        }
      );
    commit('app/addTiempoReal', snap, { root: true });
  },
  getRestaurantesBossRestaurante({ commit, rootState }) {
    let negocio = rootState.app.negocioGest;
    const arrayRest = rootState.auth.user.restaurantesRestGest;
    let devolver = [];
    var snap = db
      .collection('restaurantes')
      .where('negocio', '==', negocio)
      .onSnapshot((res) => {
        let devolver = [];
        res.forEach((doc) => {
          let aux = doc.data();
          aux.id = doc.id;
          if (arrayRest.includes(doc.id)) {
            devolver.push(aux);
          }
        });
        commit('setRestaurantesArray', devolver);
        commit('app/setRestaurantesArray', devolver, { root: true });
      });
    commit('app/addTiempoReal', snap, { root: true });
  },
  getClientesRestauranteCall({ commit, rootState }) {
    let restaurantes = rootState.app.restauranteGest;
    var getClientes = functions.httpsCallable('httpRestaurantesGetClientes');
    return getClientes(restaurantes).then((r) => {
      commit('setClientesRestaurante', r.data);
    });
  },
  addRestaurante({}, rest) {
    let id;
    if (!rest.id) {
      let slug = createSlug(rest.nombre);
      id = rest.negocio + '-' + slug;
    } else {
      id = rest.id;
    }
    return db
      .collection('restaurantes')
      .doc(id)
      .set(rest, { merge: true })
      .catch((e) => {
        console.log(e);
      });
  },
  changeActivo({}, item) {
    let b = item.inactivo ? false : true;
    return db
      .collection('restaurantes')
      .doc(item.id)
      .set({ inactivo: b }, { merge: true })
      .catch((e) => {
        console.log(e);
      });
  },
  deleteRestaurante({}, rest) {
    return db.collection('restaurantes').doc(rest.id).delete();
  },
  saveZonasReparto({ rootState }, zonas) {
    let datos = {
      zonasReparto: zonas,
    };
    let rest = rootState.app.restauranteGest;
    return db.collection('restaurantes').doc(rest).set(datos, { merge: true });
  },
  saveHorarios({ rootState }, datos) {
    /*let datos = {
            horarios : horarios
        }*/
    let rest = rootState.app.restauranteGest;
    if (datos.modoHorarioDomicilio == 'forzado_cierre')
      datos.modoHorarioDomicilioTiempo = null;
    if (datos.modoHorarioRecoger == 'forzado_cierre')
      datos.modoHorarioRecogerTiempo = null;
    return db.collection('restaurantes').doc(rest).set(datos, { merge: true });
  },

  //TPV
  savePlanoTpv({ rootState }, datos) {
    let rest = rootState.app.restauranteGest;
    return db
      .collection('restaurantes')
      .doc(rest)
      .collection('tpv')
      .doc('planos')
      .set({ plano1: datos }, { merge: true });
  },
  getPlanoTpv({ rootState }) {
    let rest = rootState.app.restauranteGest;
    return db
      .collection('restaurantes')
      .doc(rest)
      .collection('tpv')
      .doc('planos')
      .get()
      .then((r) => {
        if (r.exists) {
          return r.data();
        } else {
          return null;
        }
      });
  },
  saveUsuarioTpv({ rootState }, datos) {
    let rest = rootState.app.restauranteGest;
    let id = datos.id ? datos.id : null;
    delete datos.id;
    var ref = db
      .collection('restaurantes')
      .doc(rest)
      .collection('tpv')
      .doc('secreto')
      .collection('usuarios');
    return id
      ? ref.doc(id).set(datos, { merge: true })
      : ref.add({ activo: true, ...datos });
  },
  saveMesasTpv({ rootState }, datos) {
    let rest = rootState.app.restauranteGest;
    let id = datos.id ? datos.id : null;
    delete datos.id;
    var ref = db
      .collection('restaurantes')
      .doc(rest)
      .collection('tpv')
      .doc('secreto')
      .collection('mesas');
    return id
      ? ref.doc(id).set(datos, { merge: true })
      : ref.add({ activo: true, ...datos });
  },
  getMesasTpv({ rootState }) {
    let rest = rootState.app.restauranteGest;
    return db
      .collection('restaurantes')
      .doc(rest)
      .collection('tpv')
      .doc('secreto')
      .collection('mesas')
      .get()
      .then((r) => {
        return r.docs
          .map((u) => {
            return {
              id: u.id,
              ...u.data(),
            };
          })
          .sort((a, b) => (a.orden > b.orden ? 1 : b.orden > a.orden ? -1 : 0));
      });
  },
  getDispositivosTpv({ rootState }, restId = null) {
    let rest = !restId ? rootState.app.restauranteGest : restId;
    return db
      .collection('restaurantes')
      .doc(rest)
      .collection('tpv')
      .doc('secreto')
      .collection('dispositivos')
      .get()
      .then((r) => {
        return r.docs.map((u) => {
          return {
            id: u.id,
            ...u.data(),
          };
        });
      });
  },
  getDispositivosTpvQz({ rootState }, restId = null) {
    let rest = !restId ? rootState.app.restauranteGest : restId;
    return db
      .collection('restaurantes')
      .doc(rest)
      .collection('tpv')
      .doc('secreto')
      .collection('dispositivosqz')
      .get()
      .then((r) => {
        return r.docs.map((u) => {
          return {
            id: u.id,
            ...u.data(),
          };
        });
      });
  },
  saveDispositivoTpv({ rootState }, datos) {
    let rest = rootState.app.restauranteGest;
    let id = datos.id ? datos.id : null;
    delete datos.id;
    var ref = db
      .collection('restaurantes')
      .doc(rest)
      .collection('tpv')
      .doc('secreto')
      .collection('dispositivos');
    if (id) {
      return ref.doc(id).set(datos, { merge: true });
    } else {
      return ref.add({ activo: true, ...datos });
    }
  },
  deleteDispositivoTpv({ rootState }, id) {
    let rest = rootState.app.restauranteGest;

    return db
      .collection('restaurantes')
      .doc(rest)
      .collection('tpv')
      .doc('secreto')
      .collection('dispositivos')
      .doc(id)
      .delete();
  },

  saveModoTpv({ rootState }, datos) {
    let rest = rootState.app.restauranteGest;
    let id = datos.id ? datos.id : null;
    delete datos.id;
    var ref = db
      .collection('restaurantes')
      .doc(rest)
      .collection('tpv')
      .doc('secreto')
      .collection('modos');
    if (id) {
      return ref.doc(id).set(datos, { merge: true });
    } else {
      return ref.add({ activo: true, ...datos });
    }
  },
  saveCuentaTpv({ rootState }, datos) {
    let rest = rootState.app.restauranteGest;
    let id = datos.uid ? datos.uid : datos.id;
    delete datos.id;
    var ref = db
      .collection('restaurantes')
      .doc(rest)
      .collection('tpv')
      .doc('secreto')
      .collection('cuentas');
    if (!!id) {
      return ref.doc(id).set(datos, { merge: true });
    } else {
      return ref.add({ ...datos });
    }
  },
  getModosTpv({ rootState }) {
    let rest = rootState.app.restauranteGest;
    return db
      .collection('restaurantes')
      .doc(rest)
      .collection('tpv')
      .doc('secreto')
      .collection('modos')
      .get()
      .then((r) => {
        return r.docs
          .map((u) => {
            return {
              id: u.id,
              ...u.data(),
            };
          })
          .sort((a, b) => (a.orden > b.orden ? 1 : b.orden > a.orden ? -1 : 0));
      });
  },
  deleteModoTpv({ rootState }, m) {
    let rest = rootState.app.restauranteGest;
    return db
      .collection('restaurantes')
      .doc(rest)
      .collection('tpv')
      .doc('secreto')
      .collection('modos')
      .doc(m)
      .delete();
  },
  getCuentasTpv({ rootState, rootGetters }) {
    let rest = rootState.app.restauranteGest;
    console.log(rootState.restaurantes);
    console.log(rootGetters['app/restGestObj']);
    let negocio = rootState.app.negocioGest;
    return Promise.all([
      db
        .collection('users')
        .where('role', '==', 'tpv')
        .where('restauranteTpv', '==', rest)
        .get(),
      db
        .collection('users')
        .where('role', '==', 'tpv-comandero')
        .where('restauranteTpv', '==', rest)
        .get(),
      db
        .collection('users')
        .where('role', '==', 'tpv-repartidor')
        .where('restauranteTpv', '==', rest)
        .get(),
      db
        .collection('restaurantes')
        .doc(rest)
        .collection('tpv')
        .doc('secreto')
        .collection('cuentas')
        .get(),
    ])
      .then((r) => {
        console.log(r);
        let usuariosTpv = r[0].docs.map((u) => {
          return {
            ...u.data(),
            id: u.id,
          };
        });
        let usuariosComandero = r[1].docs.map((u) => {
          return {
            ...u.data(),
            id: u.id,
          };
        });
        let usuariosRepartidor = r[2].docs.map((u) => {
          return {
            ...u.data(),
            id: u.id,
          };
        });
        let cuentas = r[3].docs.map((u) => {
          return {
            ...u.data(),
            id: u.id,
          };
        });
        console.log(cuentas);
        let usuarios = [
          ...usuariosTpv,
          ...usuariosComandero,
          ...usuariosRepartidor,
        ];
        return usuarios.map((u) => {
          let f = cuentas.find((c) => c.id == u.id);
          return {
            ...(!!f ? f : {}),
            ...u,
          };
        });
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getStatusCuenta({}, uid) {
    return db
      .collection('status')
      .doc(uid)
      .get()
      .then((r) => {
        console.log(r.data());
      });
  },
  changeActivoUsuarioTpv({ rootState }, item) {
    let rest = rootState.app.restauranteGest;
    let b = item.activo ? false : true;
    return db
      .collection('restaurantes')
      .doc(rest)
      .collection('tpv')
      .doc('secreto')
      .collection('usuarios')
      .doc(item.id)
      .set({ activo: b }, { merge: true })
      .catch((e) => {
        console.log(e);
      });
  },
  deleteUsuarioTpv({ rootState }, usuario) {
    let rest = rootState.app.restauranteGest;
    return db
      .collection('restaurantes')
      .doc(rest)
      .collection('tpv')
      .doc('secreto')
      .collection('usuarios')
      .doc(usuario)
      .delete();
  },
  deleteMesaTpv({ rootState }, mesa) {
    let rest = rootState.app.restauranteGest;
    return db
      .collection('restaurantes')
      .doc(rest)
      .collection('tpv')
      .doc('secreto')
      .collection('mesas')
      .doc(mesa)
      .delete();
  },
  getUsuariosTpv({ rootState }) {
    let rest = rootState.app.restauranteGest;
    return db
      .collection('restaurantes')
      .doc(rest)
      .collection('tpv')
      .doc('secreto')
      .collection('usuarios')
      .get()
      .then((r) => {
        return r.docs.map((u) => {
          return {
            id: u.id,
            ...u.data(),
          };
        });
        // if (r.exists) {
        //     return r.data();
        // } else {
        //     return null
        // }
      });
  },
  guardarConfiguracionTpv({ rootState }, datos) {
    let rest = rootState.app.restauranteGest;
    var ref = db
      .collection('restaurantes')
      .doc(rest)
      .collection('tpv')
      .doc('configuracion');
    return ref.set(datos, { merge: true });
  },
  getConfiguracionTpv({ rootState }, datos) {
    let rest = rootState.app.restauranteGest;
    alert(rest);
    var ref = db
      .collection('restaurantes')
      .doc(rest)
      .collection('tpv')
      .doc('configuracion');
    return ref.get().then((r) => (r.exists ? r.data() : {}));
  },
  getAccionesTpv({ rootState }, datos) {
    let rest = rootState.app.restauranteGest;
    var ref = db
      .collection('restaurantes')
      .doc(rest)
      .collection('tpv')
      .doc('acciones');
    return ref.get().then((r) => (r.exists ? r.data() : {}));
  },
  saveAccionesTpv({ rootState }, datos) {
    let rest = rootState.app.restauranteGest;
    var ref = db
      .collection('restaurantes')
      .doc(rest)
      .collection('tpv')
      .doc('acciones');
    return ref.set(datos, { merge: true });
  },
  // FIN TPV
  async addImpresorasTickets({ rootState }, d) {
    let rest = rootState.app.restauranteGest;
    // let negocio = rootState.app.negocioGest;
    // alert(negocio + '-' + rest);
    // rest = negocio + '-' + rest;
    await db
      .collection('restaurantes')
      .doc(rest)
      .set({ id: rest }, { merge: true });
    /*var promesasImp = [];
        d.forEach((imp) => {
            promesasImp.push(db.collection('devicesPrintNode').doc(imp.impresora.toString()).set({
                dispositivos : firebase.firestore.FieldValue.arrayUnion({
                    tipo : 'restaurante',
                    tipoDevice : 'impresora',
                    id : rest
                })
            }))
        })*/
    var addTicket = db
      .collection('restaurantes')
      .doc(rest)
      .collection('secreto')
      .doc('impresorastickets')
      .set({ datos: d });
    return addTicket
      .then(() => {
        return db
          .collection('restaurantes')
          .doc(rest)
          .collection('secreto')
          .doc('impresorastickets')
          .get();
      })
      .then((r) => {
        console.log(r.data());
      })
      .catch((e) => console.log(e));
    //return Promise.all([...promesasImp,addTicket])
  },
  addOrdenadores({ rootState }, d) {
    let rest = rootState.app.restauranteGest;
    // let negocio = rootState.app.negocioGest;
    // alert(negocio + '-' + rest);
    // rest = negocio + '-' + rest;
    var promesasPc = [];
    db.collection('devicesPrintNode')
      .where('tipo', '==', 'restaurante')
      .where('tipoDevice', '==', 'ordenador')
      .where('id', '==', rest)
      .get()
      .then((snap) => {
        snap.forEach((d) => {
          d.ref.delete();
        });
      })
      .then(() => {
        d.forEach((pc) => {
          promesasPc.push(
            db.collection('devicesPrintNode').doc(pc.toString()).set({
              tipo: 'restaurante',
              tipoDevice: 'ordenador',
              id: rest,
            })
          );
        });
      });
    var addPcs = db
      .collection('restaurantes')
      .doc(rest)
      .collection('secreto')
      .doc('ordenadores')
      .set({ datos: d });
    return Promise.all([...promesasPc, addPcs]);
  },
  getImpresorasTickets({ rootState, commit }) {
    let rest = rootState.app.restauranteGest;
    var res = [];
    return db
      .collection('restaurantes')
      .doc(rest)
      .collection('secreto')
      .doc('impresorastickets')
      .get()
      .then((snap) => {
        if (snap.exists) {
          let datosimp = snap.data();
          datosimp.datos.forEach((d) => {
            res.push(d);
          });
          commit('setImpresorasRest', res);
        }
      });
  },
  getOrdenadores({ rootState, commit }) {
    let rest = rootState.app.restauranteGest;

    var res = [];
    return db
      .collection('restaurantes')
      .doc(rest)
      .collection('secreto')
      .doc('ordenadores')
      .get()
      .then((snap) => {
        if (snap.exists) {
          let datosimp = snap.data();
          datosimp.datos.forEach((d) => {
            res.push(d);
          });
          commit('setOrdenadoresRest', res);
        }
      });
  },
  getPedidosRestaurante({ state, commit, dispatch, rootState }) {
    //NO TERMINADO
    var snap = dispatch('pedidos/setRangoDefecto', {}, { root: true }).then(
      () => {
        var snap = db
          .collection('pedidos')
          .where('fechaServidor', '>=', rootState.pedidos.diaComprobando1)
          .where('fechaServidor', '<=', rootState.pedidos.diaComprobando2)
          .onSnapshot((snapDoc) => {
            var res = [];
            snapDoc.forEach((e) => {
              res.push(e.data());
            });
            commit('setPedidosArray', res);
            return;
          });
        commit('app/addTiempoReal', snap, { root: true });
      }
    );
    commit('app/addTiempoReal', snap, { root: true });
  },
  saveProductosAsociados({ rootState }, asociaciones) {
    let datos = {
      productosAsociados: asociaciones,
    };
    let rest = rootState.app.restauranteGest;
    return db.collection('restaurantes').doc(rest).set(datos, { merge: true });
  },
  saveMapeoAsociados({}, mapeos) {
    var promesas = [];
    mapeos
      .filter((m) => !!m)
      .forEach((m) => {
        promesas.push(
          db
            .collection('restaurantes')
            .doc(m.rest)
            .get()
            .then((r) => {
              if (r.exists) {
                const d = r.data();
                let asociados = d.productosMapeados ? d.productosMapeados : [];
                let foundIndex = asociados.findIndex((a) => a.id == m.producto);
                if (foundIndex > -1) {
                  asociados[foundIndex] = {
                    ...asociados[foundIndex],
                    mapeoRest: m.codigo,
                  };
                  return r.ref.set(
                    {
                      productosMapeados: asociados,
                    },
                    { merge: true }
                  );
                } else {
                  asociados.push({
                    id: m.producto,
                    mapeoRest: m.codigo,
                  });
                  return r.ref.set(
                    {
                      productosMapeados: asociados,
                    },
                    { merge: true }
                  );
                }
              }
            })
        );
      });
    return Promise.all(promesas);
  },
  saveMapeoOpcionAsociados({}, mapeos) {
    var promesas = [];
    mapeos.forEach((m) => {
      promesas.push(
        db
          .collection('restaurantes')
          .doc(m.rest)
          .get()
          .then((r) => {
            if (r.exists) {
              const d = r.data();
              let asociados = d.productosMapeados ? d.productosMapeados : [];
              let foundIndex = asociados.findIndex((a) => a.id == m.producto);
              if (foundIndex > -1) {
                asociados[foundIndex].opciones = asociados[foundIndex].opciones
                  ? asociados[foundIndex].opciones
                  : [];
                let opciones = asociados[foundIndex].opciones;
                let foundIndexOpcion = opciones.findIndex(
                  (op) => op.id === m.opcion
                );
                if (foundIndexOpcion > -1) {
                  asociados[foundIndex].opciones[foundIndexOpcion] = {
                    ...asociados[foundIndex].opciones[foundIndexOpcion],
                    mapeoRest: m.codigo,
                  };
                } else {
                  asociados[foundIndex].opciones.push({
                    id: m.opcion,
                    mapeoRest: m.codigo,
                  });
                }
                return r.ref.set(
                  {
                    productosMapeados: asociados,
                  },
                  { merge: true }
                );
              } else {
                return Promise.reject('El producto base no está asociado');
                // asociados.push({
                //     id: m.producto,
                //     mapeoRest: m.codigo
                // })
                // return r.ref.set({
                //     productosMapeados: asociados
                // }, { merge: true })
              }
            }
          })
      );
    });
    return Promise.all(promesas);
  },
  saveEmails({ rootState }, payload) {
    const rest = rootState.app.restauranteGest;
    return db
      .collection('restaurantes')
      .doc(rest)
      .collection('secreto')
      .doc('emails')
      .set(payload.emails, { merge: true });
  },
  saveConfGeneral({ rootState }, data) {
    let payload = JSON.parse(JSON.stringify(data));
    delete payload.confGeneral.tiempoRecoger;
    delete payload.confGeneral.tiempoDomicilio;
    const rest = rootState.app.restauranteGest;
    payload.tiempoDomicilio = parseInt(payload.tiempoDomicilio);
    payload.tiempoRecogida = parseInt(payload.tiempoRecogida);
    return db
      .collection('restaurantes')
      .doc(rest)
      .set(payload, { merge: true });
  },
  savePersonalizacion({ rootState }, payload) {
    const rest = rootState.app.restauranteGest;
    return db
      .collection('restaurantes')
      .doc(rest)
      .set(payload, { merge: true });
  },
  saveNeo({ rootState }, datos) {
    const rest = rootState.app.restauranteGest;
    return db
      .collection('restaurantes')
      .doc(rest)
      .collection('secreto')
      .doc('neo')
      .set(datos, { merge: true });
  },
  getEmails({ rootState }) {
    const rest = rootState.app.restauranteGest;
    return db
      .collection('restaurantes')
      .doc(rest)
      .collection('secreto')
      .doc('emails')
      .get()
      .then((r) => {
        if (r.exists) {
          return r.data();
        }
      });
  },
  getNeo({ rootState }) {
    const rest = rootState.app.restauranteGest;
    return db
      .collection('restaurantes')
      .doc(rest)
      .collection('secreto')
      .doc('neo')
      .get()
      .then((r) => {
        if (r.exists) {
          return r.data();
        }
      });
  },
  actualizarNeoRestaurante({ rootState }) {
    const rest = rootState.app.restauranteGest;
    var restauranteNeo = functions.httpsCallable(
      'httpNeoActualizarNeoRestaurante'
    );
    return restauranteNeo(rest);
  },
  saveFacturacion({ rootState }, payload) {
    return db
      .collection('restaurantes')
      .doc(payload.rest)
      .collection('secreto')
      .doc('facturacion')
      .set(payload.facturacion, { merge: true });
  },
  getFacturacion({}, id) {
    return db
      .collection('restaurantes')
      .doc(id)
      .collection('secreto')
      .doc('facturacion')
      .get()
      .then((r) => {
        if (r.exists) {
          return r.data();
        }
      });
  },
  getUsuariosCuentasTpv({}, restId) {
    return Promise.all([
      db
        .collection('users')
        .where('role', '==', 'tpv')
        .where('restauranteTpv', '==', restId)
        .get(),
      db
        .collection('restaurantes')
        .doc(restId)
        .collection('tpv')
        .doc('secreto')
        .collection('cuentas')
        .get(),
    ]).then((r) => {
      let usuarios = r[0].docs.map((u) => {
        return {
          ...u.data(),
          id: u.id,
        };
      });
      let cuentas = r[1].docs.map((u) => {
        return {
          ...u.data(),
          id: u.id,
        };
      });
      return usuarios.map((u) => {
        let f = cuentas.find((c) => c.id == u.id);
        return {
          ...(!!f ? f : {}),
          ...u,
        };
      });
    });
  },
  comprobarConexion({ dispatch, rootState }, restObj) {
    var uidUsuario;
    if (restObj.printNode) {
      return dispatch('comprobarConexionPrintNode', restObj);
    } else {
      return dispatch('getUsuariosCuentasTpv', restObj.id)
        .then((r) => {
          let arrayUsuariosImprimen = r.filter((i) => !!i.marcaConectado);

          uidUsuario = arrayUsuariosImprimen[0].id;
          if (arrayUsuariosImprimen && arrayUsuariosImprimen[0]) {
            return db
              .collection('restaurantes')
              .doc(restObj.id)
              .collection('tpv')
              .doc('acciones')
              .set({ comprobarConexion: null }, { merge: true })
              .then(() => {
                return db
                  .collection('restaurantes')
                  .doc(restObj.id)
                  .collection('tpv')
                  .doc('acciones')
                  .set({ comprobarConexion: uidUsuario }, { merge: true });
              });
          }
        })
        .then((r) => {
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve();
            }, 5000);
          });
        })
        .then(() => {
          return db
            .collection('restaurantes')
            .doc(restObj.id)
            .collection('tpv')
            .doc('acciones')
            .get();
        })
        .then((r) => {
          if (r.exists) {
            let comprobar = r.data().comprobarConexion;

            if (!!comprobar) {
              //está esperando para comprobar, por lo que no estác onectado
              var isOfflineForDatabase = {
                uid: uidUsuario,
                state: 'offline',
                rest: restObj.id,
                last_changed: firebase.database.ServerValue.TIMESTAMP,
              };

              var userStatusDatabaseRef = firebase
                .database()
                .ref('/status/' + rootState.auth.user.uid);
              return userStatusDatabaseRef
                .set(isOfflineForDatabase)
                .then(() => {
                  return db
                    .collection('restaurantes')
                    .doc(restObj.id)
                    .collection('tpv')
                    .doc('acciones')
                    .set({ comprobarConexion: null }, { merge: true });
                });
            }
          }
        });
    }
  },
  comprobarConexionPrintNode({}, item) {
    var comprobar = functions.httpsCallable('httpPrintnodeComprobarConexion');
    return comprobar({
      id: item.id,
      negocio: item.negocio,
    });
  },
  comprobarConexionLocal({}, item) {
    var comprobar = functions.httpsCallable('httpPrintnodeComprobarConexion');
    return comprobar({
      id: item.id,
      negocio: item.negocio,
    });
  },
  saveDatos({}, item) {
    //guarda cualquier dato dentro del objeto, en el restaurante item.id
    return db
      .collection('restaurantes')
      .doc(item.id)
      .set(item, { merge: true });
  },
  enlaceStripe({}, id) {
    var getUrl = functions.httpsCallable(
      'httpStripeGetUrlDashboardRestaurante'
    );
    return getUrl(id);
  },
  crearSiteVromo({}, id) {
    var c = functions.httpsCallable('httpVromoCrearSite');
    return c(id);
  },
  actualizarSiteVromo({}, id) {
    var a = functions.httpsCallable('httpVromoActualizarSite');
    return a(id);
  },

  //Reservas
  saveConfiguracionReservas({ rootState }, conf) {
    const rest = rootState.app.restauranteGest;
    return db
      .collection('restaurantes')
      .doc(rest)
      .set({ confReservas: conf }, { merge: true });
  },
  getConfiguracionReservas({ rootState, commit, rootGetters }) {
    const rest = rootState.app.restauranteGest;
    return rootGetters['app/restGestObj'].confReservas
      ? rootGetters['app/restGestObj'].confReservas
      : {};
    //se guarda ne ele reesetaurante
    return db
      .collection('restaurantes')
      .doc(rest)
      .collection('reservas')
      .doc('configuracion')
      .get()
      .then((r) => {
        if (r.exists) {
          commit('setReservasConfiguracion', r.data()); //por si queremos usarlo lectura
          return r.data(); // para la vista reservas configuración, asociarla a un objeto modificable
        } else {
          commit('setReservasConfiguracion', {});
        }
      });
  },
  saveReserva({ rootState }, reserva) {
    const rest = rootState.app.restauranteGest;
    // let mes = moment.unix(reserva.seleccionRango[0]).format('YYYY-MM')
    // let dia = moment.unix(reserva.seleccionRango[0]).format('DD')
    // console.log(mes);
    // console.log(dia);
    if (!reserva.id) {
      return db
        .collection('restaurantes')
        .doc(rest)
        .collection('eventos')
        .add({ ...reserva, tipo: 'reserva' });
    } else {
      return db
        .collection('restaurantes')
        .doc(rest)
        .collection('eventos')
        .doc(reserva.id)
        .set(reserva, { merge: true });
    }
  },
  getReservas({ rootState }, fecha) {
    const rest = rootState.app.restauranteGest;
    return db
      .collection('restaurantes')
      .doc(rest)
      .collection('eventos')
      .where('tipo', '==', 'reserva')
      .where('reservaInicioUnix', '>', fecha.inicio)
      .where('reservaInicioUnix', '<', fecha.fin)
      .get()
      .then((r) => {
        return r.docs.map((reserva) => {
          return {
            ...reserva.data(),
            id: reserva.id,
          };
        });
      });
  },
  confirmarReserva({ rootState }, reserva) {
    const rest = rootState.app.restauranteGest;

    var conf = functions.httpsCallable('httpRestaurantesConfirmarReserva');
    return conf({
      reserva: reserva,
      rest: rest,
    }).then((r) => {
      if (!r.data.ok) {
        return Promise.reject(r.data.error);
      } else {
        return Promise.resolve();
      }
    });
  },
  getConfTpv({ state, commit }) {
    return Promise.all(
      state.restaurantesArray.map((r) => {
        return db
          .collection('restaurantes')
          .doc(r.id)
          .collection('tpv')
          .doc('configuracion')
          .onSnapshot((d) => {
            console.log(d.exists);
            var confTpv;
            if (d.exists) {
              var conf = d.data();
              //commit('setConfTpv', conf);
              console.log(conf);
              //r.confTpv = conf;
              confTpv = { id: r.id, confTpv: conf };
            } else {
              //r.confTpv = false;
              confTpv = { id: r.id, confTpv: null };
            }
            commit('setConfTpvRest', confTpv); //se agregan uno a uno
          });
      })
    ).catch((e) => console.log(e));
  },
  getModosRestaurantes({ state, commit }) {
    return Promise.all(
      state.restaurantesArray.map((r) => {
        return db
          .collection('restaurantes')
          .doc(r.id)
          .collection('tpv')
          .doc('secreto')
          .collection('modos')
          .get()
          .then((res) => {
            // r.docs.map(d => {
            return res.docs
              .map((m) => {
                return {
                  ...m.data(),
                  id: m.id,
                  nombreModo: r.nombre + ' ' + m.data().nombre,
                };
              })
              .sort((a, b) =>
                a.orden > b.orden ? 1 : b.orden > a.orden ? -1 : 0
              );
          });
      })
    )
      .then((r) => {
        commit('setModosTpvRest', r.flat());
      })
      .catch((e) => console.log(e));
  },
};
